import React from 'react';
export const SearchSvg: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9459 16.7062L12.1027 10.863C13.0094 9.69071 13.4999 8.25746 13.4999 6.74997C13.4999 4.94548 12.7957 3.25349 11.5222 1.97774C10.2487 0.701997 8.55221 0 6.74997 0C4.94773 0 3.25124 0.704247 1.97774 1.97774C0.701997 3.25124 0 4.94548 0 6.74997C0 8.55221 0.704247 10.2487 1.97774 11.5222C3.25124 12.7979 4.94548 13.4999 6.74997 13.4999C8.25746 13.4999 9.68846 13.0094 10.8607 12.1049L16.7039 17.9459C16.7211 17.9631 16.7414 17.9767 16.7638 17.9859C16.7862 17.9952 16.8102 18 16.8344 18C16.8587 18 16.8827 17.9952 16.9051 17.9859C16.9274 17.9767 16.9478 17.9631 16.9649 17.9459L17.9459 16.9672C17.9631 16.95 17.9767 16.9297 17.9859 16.9073C17.9952 16.8849 18 16.8609 18 16.8367C18 16.8124 17.9952 16.7884 17.9859 16.766C17.9767 16.7437 17.9631 16.7233 17.9459 16.7062ZM10.314 10.314C9.35996 11.2657 8.09546 11.7899 6.74997 11.7899C5.40448 11.7899 4.13998 11.2657 3.18599 10.314C2.23424 9.35996 1.70999 8.09546 1.70999 6.74997C1.70999 5.40448 2.23424 4.13773 3.18599 3.18599C4.13998 2.23424 5.40448 1.70999 6.74997 1.70999C8.09546 1.70999 9.36221 2.23199 10.314 3.18599C11.2657 4.13998 11.7899 5.40448 11.7899 6.74997C11.7899 8.09546 11.2657 9.36221 10.314 10.314Z"
        fill="#52555E"
      />
    </svg>
  );
};
